import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhxCheckboxComponent } from './checkbox.component';
import { PhxCheckboxRequiredValidatorDirective } from './checkbox-required-validator.directive';
import { PhxIconModule } from '../icon/icon.module';

@NgModule({
  imports: [
    CommonModule,
    PhxIconModule,
  ],
  declarations: [PhxCheckboxComponent, PhxCheckboxRequiredValidatorDirective],
  exports: [PhxCheckboxComponent, PhxCheckboxRequiredValidatorDirective],
})
export class PhxCheckboxModule { }
